/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SlashIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAApUlEQVR4nO2VMQoCMRBF06rHELzJFgvJzG/CH2Fvso16JS28jIKn0K1WFgsjWM4WQT+kSPN+mEeYEH46EWyT2iCw8XXYu8FzzgtRXt5wewDcuBUktX0BH6e7GxzgWpT3ouDWNN3KrUDUjuXrRUz84GLyMRrwXLNY7mYVG2Nc1iE2gTqvWNj1L/ZrkvJUzl51m4JX6hYrsEPFPxbsiyUyTGvRDV5lnhd1tv7O6+ArAAAAAElFTkSuQmCC)
 */
export const SlashIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M19.12 2a.5.5 0 0 1 .43.76L8.22 21.64a.75.75 0 0 1-.64.36h-2.7a.5.5 0 0 1-.43-.76L15.78 2.36a.75.75 0 0 1 .64-.36h2.7Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
